import * as React from "react";
import People from './People'

interface IPeople {
    count: number
}

export default class PeopleGrid extends React.PureComponent<IPeople, {}> {
    public render() {
      const remainder = this.props.count % 10
      const rows = Math.floor(this.props.count / 10)
      const men = []
      for (let i = 0; i < rows; i++ ) {
          men.push(<People normal={10} key={`${i.toString()}` }/>) 
      }
      if (remainder !== 0) {
        men.push(<People normal={remainder} key={"remainder"}/>) 
      }
      return (
          <div>
              {men}
          </div>
      );
    }
  }


// WEBPACK FOOTER //
// ./src/components/general/PeopleGrid.tsx